import 'styled-components';

import light from './light';

const dark: typeof light = {
  ...light,
  colors: {
    ...light.colors,

    BG1: '#0f0f0f',
    BG2: '#171717',

    IC1: '#FFF',
    IC2: '#fff',

    TEXT1: '#FFF',
    TEXT2: '#fff',
    TEXT3: '#999',
    TEXT4: 'rgba(255,255,255,0.7)',

    BTNBG: '#333',
    BTNLABEL: '#FFF',
    BTNBGH: '#FFF',
    BTNLABELH: '#333',

    COLOR_1: '#171717',
    COLOR_2: '#171717',

    LIGHT1: 'rgba(255,255,255,0.05)',
    LIGHT2: 'rgba(255,255,255,0.03)',
    LIGHT3: 'rgba(255,255,255,0.08)',
    LIGHT4: 'rgba(255,255,255,0.02)',
    LIGHT5: '#000',
    LIGHT6: 'rgba(255,255,255,0.01)',
    LIGHT7: 'rgba(255,255,255,0.05)',

    SHADOW: 'rgba(255,255,255,0.02)',

    BORDER: 'rgba(255,255,255,0.1)',

    BAR1: '#333',
    BAR2: '#222',
    BAR3: '#555',
  },
};

export default dark;
